<mat-menu
  #customizerMenu="matMenu"
  class="customizer-menu"
>
  <!-- Sort By -->
  <button
    mat-menu-item
    [matMenuTriggerFor]="sortMenu"
  >
    <mat-icon>sort</mat-icon>
    <span>{{ T.F.TASK_VIEW.CUSTOMIZER.SORT_TEMPORARY | translate }}</span>
    @if (customizerService.selectedSort() !== 'default') {
      <span class="current-value">
        {{ getSortLabel(customizerService.selectedSort()) | translate }}
      </span>
    }
  </button>

  <!-- Sort Permanently -->
  <button
    mat-menu-item
    [matMenuTriggerFor]="sortPermanentMenu"
  >
    <mat-icon>sort</mat-icon>
    <span>{{ T.F.TASK_VIEW.CUSTOMIZER.SORT_PERMANENT | translate }}</span>
  </button>

  <!-- Group By -->
  <button
    mat-menu-item
    [matMenuTriggerFor]="groupMenu"
  >
    <mat-icon>group_work</mat-icon>
    <span>{{ T.F.TASK_VIEW.CUSTOMIZER.GROUP_BY | translate }}</span>
    @if (customizerService.selectedGroup() !== 'default') {
      <span class="current-value">
        {{ getGroupLabel(customizerService.selectedGroup()) | translate }}
      </span>
    }
  </button>

  <!-- Filter By -->
  <button
    mat-menu-item
    [matMenuTriggerFor]="filterMenu"
  >
    <mat-icon>filter_alt</mat-icon>
    <span>{{ T.F.TASK_VIEW.CUSTOMIZER.FILTER_BY | translate }}</span>
    @if (customizerService.selectedFilter() !== 'default') {
      <span class="current-value">
        {{ getFilterLabel(customizerService.selectedFilter()) | translate }}
      </span>
    }
  </button>

  <mat-divider></mat-divider>

  <!-- Reset All -->
  <button
    mat-menu-item
    (click)="onResetAll()"
  >
    <mat-icon>refresh</mat-icon>
    <span>{{ T.F.TASK_VIEW.CUSTOMIZER.RESET_ALL | translate }}</span>
  </button>
</mat-menu>

<!-- Sort submenu -->
<mat-menu #sortMenu="matMenu">
  @for (opt of sortOptions; track opt.value) {
    <button
      mat-menu-item
      (click)="customizerService.setSort(opt.value)"
      [class.active]="customizerService.selectedSort() === opt.value"
    >
      <span class="menu-item-content">
        <span>{{ opt.label | translate }}</span>
        @if (customizerService.selectedSort() === opt.value) {
          <mat-icon class="check-icon">check</mat-icon>
        }
      </span>
    </button>
  }
</mat-menu>

<!-- Sort Permanent submenu -->
<mat-menu #sortPermanentMenu="matMenu">
  @for (opt of sortOptions; track opt.value) {
    @if (opt.value !== 'default') {
      <button
        mat-menu-item
        (click)="onSortPermanentOption(opt.value)"
      >
        <span class="menu-item-content">
          <span>{{ opt.label | translate }}</span>
        </span>
      </button>
    }
  }
</mat-menu>

<!-- Group submenu -->
<mat-menu #groupMenu="matMenu">
  @for (opt of groupOptions; track opt.value) {
    <button
      mat-menu-item
      (click)="customizerService.setGroup(opt.value)"
      [class.active]="customizerService.selectedGroup() === opt.value"
    >
      <span class="menu-item-content">
        <span>{{ opt.label | translate }}</span>
        @if (customizerService.selectedGroup() === opt.value) {
          <mat-icon class="check-icon">check</mat-icon>
        }
      </span>
    </button>
  }
</mat-menu>

<!-- Filter submenu -->
<mat-menu #filterMenu="matMenu">
  <button
    mat-menu-item
    (click)="onFilterSelect('default')"
    [class.active]="customizerService.selectedFilter() === 'default'"
  >
    <span class="menu-item-content">
      <span>{{ T.F.TASK_VIEW.CUSTOMIZER.FILTER_DEFAULT | translate }}</span>
      @if (customizerService.selectedFilter() === 'default') {
        <mat-icon class="check-icon">check</mat-icon>
      }
    </span>
  </button>

  <button
    mat-menu-item
    [matMenuTriggerFor]="filterTagMenu"
    [class.active]="customizerService.selectedFilter() === 'tag'"
  >
    <span class="menu-item-content">
      <span>{{ T.F.TASK_VIEW.CUSTOMIZER.FILTER_TAG | translate }}</span>
      @if (customizerService.selectedFilter() === 'tag') {
        <mat-icon class="check-icon">check</mat-icon>
      }
    </span>
  </button>

  <button
    mat-menu-item
    [matMenuTriggerFor]="filterProjectMenu"
    [class.active]="customizerService.selectedFilter() === 'project'"
  >
    <span class="menu-item-content">
      <span>{{ T.F.TASK_VIEW.CUSTOMIZER.FILTER_PROJECT | translate }}</span>
      @if (customizerService.selectedFilter() === 'project') {
        <mat-icon class="check-icon">check</mat-icon>
      }
    </span>
  </button>

  <button
    mat-menu-item
    [matMenuTriggerFor]="filterScheduledDateMenu"
    [class.active]="customizerService.selectedFilter() === 'scheduledDate'"
  >
    <span class="menu-item-content">
      <span>{{ T.F.TASK_VIEW.CUSTOMIZER.FILTER_SCHEDULED_DATE | translate }}</span>
      @if (customizerService.selectedFilter() === 'scheduledDate') {
        <mat-icon class="check-icon">check</mat-icon>
      }
    </span>
  </button>

  <button
    mat-menu-item
    [matMenuTriggerFor]="filterEstimatedTimeMenu"
    [class.active]="customizerService.selectedFilter() === 'estimatedTime'"
  >
    <span class="menu-item-content">
      <span>{{ T.F.TASK_VIEW.CUSTOMIZER.FILTER_ESTIMATED_TIME | translate }}</span>
      @if (customizerService.selectedFilter() === 'estimatedTime') {
        <mat-icon class="check-icon">check</mat-icon>
      }
    </span>
  </button>

  <button
    mat-menu-item
    [matMenuTriggerFor]="filterTimeSpentMenu"
    [class.active]="customizerService.selectedFilter() === 'timeSpent'"
  >
    <span class="menu-item-content">
      <span>{{ T.F.TASK_VIEW.CUSTOMIZER.FILTER_TIME_SPENT | translate }}</span>
      @if (customizerService.selectedFilter() === 'timeSpent') {
        <mat-icon class="check-icon">check</mat-icon>
      }
    </span>
  </button>
</mat-menu>

<!-- Filter: Tag submenu -->
<mat-menu #filterTagMenu="matMenu">
  <div
    class="menu-input-wrapper"
    (click)="$event.stopPropagation()"
  >
    <mat-form-field
      class="menu-input"
      subscriptSizing="dynamic"
    >
      <input
        matInput
        [ngModel]="customizerService.filterInputValue()"
        (ngModelChange)="onFilterInputChange('tag', $event)"
        [placeholder]="T.F.TASK_VIEW.CUSTOMIZER.ENTER_TAG | translate"
        (keydown.enter)="$event.stopPropagation()"
      />
    </mat-form-field>
  </div>
</mat-menu>

<!-- Filter: Project submenu -->
<mat-menu #filterProjectMenu="matMenu">
  <div
    class="menu-input-wrapper"
    (click)="$event.stopPropagation()"
  >
    <mat-form-field
      class="menu-input"
      subscriptSizing="dynamic"
    >
      <input
        matInput
        [ngModel]="customizerService.filterInputValue()"
        (ngModelChange)="onFilterInputChange('project', $event)"
        [placeholder]="T.F.TASK_VIEW.CUSTOMIZER.ENTER_PROJECT | translate"
        (keydown.enter)="$event.stopPropagation()"
      />
    </mat-form-field>
  </div>
</mat-menu>

<!-- Filter: Scheduled Date submenu -->
<mat-menu #filterScheduledDateMenu="matMenu">
  @for (option of scheduledPresets; track option.value) {
    <button
      mat-menu-item
      (click)="onFilterWithValue('scheduledDate', option.value)"
      [class.active]="
        customizerService.selectedFilter() === 'scheduledDate' &&
        customizerService.filterInputValue() === option.value
      "
    >
      <span class="menu-item-content">
        <span>{{ option.label | translate }}</span>
        @if (
          customizerService.selectedFilter() === 'scheduledDate' &&
          customizerService.filterInputValue() === option.value
        ) {
          <mat-icon class="check-icon">check</mat-icon>
        }
      </span>
    </button>
  }
</mat-menu>

<!-- Filter: Estimated Time submenu -->
<mat-menu #filterEstimatedTimeMenu="matMenu">
  @for (option of timePresets; track option.value) {
    <button
      mat-menu-item
      (click)="onFilterWithValue('estimatedTime', option.value)"
      [class.active]="
        customizerService.selectedFilter() === 'estimatedTime' &&
        customizerService.filterInputValue() === option.value
      "
    >
      <span class="menu-item-content">
        <span>{{ option.label | translate }}</span>
        @if (
          customizerService.selectedFilter() === 'estimatedTime' &&
          customizerService.filterInputValue() === option.value
        ) {
          <mat-icon class="check-icon">check</mat-icon>
        }
      </span>
    </button>
  }
</mat-menu>

<!-- Filter: Time Spent submenu -->
<mat-menu #filterTimeSpentMenu="matMenu">
  @for (option of timePresets; track option.value) {
    <button
      mat-menu-item
      (click)="onFilterWithValue('timeSpent', option.value)"
      [class.active]="
        customizerService.selectedFilter() === 'timeSpent' &&
        customizerService.filterInputValue() === option.value
      "
    >
      <span class="menu-item-content">
        <span>{{ option.label | translate }}</span>
        @if (
          customizerService.selectedFilter() === 'timeSpent' &&
          customizerService.filterInputValue() === option.value
        ) {
          <mat-icon class="check-icon">check</mat-icon>
        }
      </span>
    </button>
  }
</mat-menu>
